import {
  MyCardsLayout,
  loader,
} from '@sorare/gameplay/src/layouts/my-cards/MyCardsLayout';

import { LayoutParams } from './__generated__/routeParams';

export { loader };
const FootballMyCardsLayout = () => {
  return <MyCardsLayout<LayoutParams> />;
};

export default FootballMyCardsLayout;
